import * as React from 'react';
import warning from 'warning';
import classnames from 'classnames';
import Header, { PageLinkPropType } from './Header';

var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};

var Page = function Page(props) {
  var name = props.name,
      icon = props.icon,
      title = props.title,
      description = props.description,
      links = props.links,
      children = props.children,
      component = props.component;
  warning(!(component && children && !isEmptyChildren(children)), "Vous ne devriez pas d\xE9finir la prop. `component` et `children` en m\xEAme temps pour la m\xEAme `Page`, " + "`children` va \xEAte ignor\xE9.");
  warning(!(!title && (icon || description || links && links.length)), "Vous avec d\xE9fini certaines des props. suivantes pour le " + "component `Page`: `icon`, `description`, `links`.\n" + "Ces props. ne seront pas utilis\xE9es si vous ne fournissez pas " + "aussi la prop. `title`.");

  var _children = component ? React.createElement(component) : children;

  return React.createElement("div", {
    className: classnames('Page', "Page--".concat(name))
  }, title && React.createElement(Header, {
    icon: icon,
    title: title,
    description: description,
    links: links
  }), React.createElement("div", {
    className: "Page__body"
  }, _children));
};

Page.defaultProps = {
  icon: undefined,
  title: undefined,
  description: undefined,
  links: [],
  component: undefined,
  children: undefined
};
export default Page;